import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icon-road.svg'
import _imports_1 from '@/assets/icon-train.svg'
import _imports_2 from '@/assets/icon-area.svg'


const _hoisted_1 = { class: "jr-fixed jr-top-0 jr-left-0 jr-z-40 jr-h-screen jr-w-sidebar jr-bg-white jr-pt-10 jr-shadow-lg" }
const _hoisted_2 = {
  key: 0,
  class: "jr-w-full jr-p-6 jr-cursor-pointer jr-relative"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "jr-inline-block jr-mr-5 jr-align-text-bottom",
  src: _imports_0,
  alt: "road"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-base jr-font-bold jr-inline-block jr-align-middle jr-text-blue-bold" }, "道路", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "jr-w-full jr-p-6 jr-cursor-pointer jr-relative"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "jr-inline-block jr-mr-5 jr-align-top",
  src: _imports_1,
  alt: "train"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-base jr-font-bold jr-inline-block jr-align-middle jr-text-blue-bold" }, "駅・鉄道", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "jr-w-full jr-p-6 jr-cursor-pointer jr-relative"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "jr-inline-block jr-mr-5 jr-align-text-bottom",
  src: _imports_2,
  alt: "area"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-base jr-font-bold jr-inline-block jr-align-top jr-text-blue-bold" }, "エリア", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UISpeechBubble = _resolveComponent("UISpeechBubble")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_ctx.displayMenus.includes('road'))
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleNav(_ctx.Nav.Road))),
              onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMouseHover(_ctx.Nav.Road))),
              onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
            }, _hoisted_5, 32),
            (_ctx.activeNav === _ctx.Nav.Road)
              ? (_openBlock(), _createBlock(_component_UISpeechBubble, {
                  key: 0,
                  class: "jr-w-45 jr--right-50 jr-top-0 jr-bottom-0 jr-m-auto",
                  label: "道路区間来訪者の可視化"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.displayMenus.includes('railway'))
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleNav(_ctx.Nav.Train))),
              onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMouseHover(_ctx.Nav.Train))),
              onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
            }, _hoisted_9, 32),
            (_ctx.activeNav === _ctx.Nav.Train)
              ? (_openBlock(), _createBlock(_component_UISpeechBubble, {
                  key: 0,
                  class: "jr-w-55 jr--right-60 jr-top-0 jr-bottom-0 jr-m-auto",
                  label: "路線利用者／非利用者の可視化"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.displayMenus.includes('area'))
        ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleNav(_ctx.Nav.Area))),
              onMouseover: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleMouseHover(_ctx.Nav.Area))),
              onMouseleave: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
            }, _hoisted_13, 32),
            (_ctx.activeNav === _ctx.Nav.Area)
              ? (_openBlock(), _createBlock(_component_UISpeechBubble, {
                  key: 0,
                  class: "jr-w-45 jr--right-50 jr-top-0 jr-bottom-0 jr-m-auto",
                  label: "エリア来訪者の可視化"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}